// project import
import main from './main';
import makeAppointment from './makeAppointment';
import medCard from './medcard';
import myAppointments from './myAppointments';
import promotions from './promotions';
import contacts from './contacts';
import chatFeedBack from './chatFeedback';
import services from './services';
import payment from './payment';
import basket from './basket';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [main, makeAppointment, medCard, myAppointments, promotions, contacts, chatFeedBack, services, payment, basket]
};

export default menuItems;
